import React from 'react'
import {
  DetailsList,
  DetailsListLayoutMode,
  CheckboxVisibility
} from 'office-ui-fabric-react/lib/DetailsList'
import { ActionButton } from 'office-ui-fabric-react/lib/Button'
import { Link } from 'office-ui-fabric-react/lib/Link'

const Contributors = ({contributors}) => 
  <span>
  {
    (contributors && contributors.length > 0)
      ? contributors.map(contributor => `${contributor.first} ${contributor.last}`).join(', ')
      : ' '
  }
  </span>

function renderCell(item, index, column) {
  const handleAddSource = column.handleAddSource
  return (
    <div className="eb-action-list-item">
      <div className="eb-action-list-item-text">
        <div className="eb-citation-title ms-fontSize-m">{item.display.title}</div>
        <div>
          {
            item.data.contributors
              ? <Contributors contributors={item.data.contributors} />
              : <Link target="_blank" href={item.display.displayurl}>{item.display.displayurl}</Link>
          }
          {
            item.display.year && <span>, {item.display.year}</span>
          }
        </div>
      </div>
      <ActionButton
        className="eb-action-list-item-action"
        iconProps={ { iconName: 'Add' } }
        onClick={() => handleAddSource(item)}
      >Select</ActionButton>
    </div>
  )

}

const SearchResults = ({sources, handleAddSource, handleClose}) =>
  <div>
    <div className="eb-action-list-actions">
      <ActionButton
        iconProps={ { iconName: 'Back' } }
        title='Back'
        onClick={() => handleClose()}
      >Back to bibliography</ActionButton>
    </div>
  <DetailsList
    columns={[{key: 'source', handleAddSource}]}
    items={sources}
    setKey='set'
    layoutMode={ DetailsListLayoutMode.justified }
    isHeaderVisible={ false }
    checkboxVisibility={CheckboxVisibility.hidden}
    onRenderItemColumn={renderCell}
  />
  </div>


  export default SearchResults



// WEBPACK FOOTER //
// ./src/SearchResults.js